import { render, staticRenderFns } from "./ServicesAuthorized.vue?vue&type=template&id=5f48d805"
import script from "./ServicesAuthorized.vue?vue&type=script&lang=js"
export * from "./ServicesAuthorized.vue?vue&type=script&lang=js"
import style0 from "./ServicesAuthorized.vue?vue&type=style&index=0&id=5f48d805&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f48d805')) {
      api.createRecord('5f48d805', component.options)
    } else {
      api.reload('5f48d805', component.options)
    }
    module.hot.accept("./ServicesAuthorized.vue?vue&type=template&id=5f48d805", function () {
      api.rerender('5f48d805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BusinessUnitForm/components/ServicesAuthorized.vue"
export default component.exports